import { LucideIcon } from "lucide-react";
import { ReactNode } from "react";
import Link from "next/link";
import { Button } from "@/components/shadcn/button";
import { NoxusIcon } from "../shadcn/icons";

const NoxusEmptyBlock = ({
  title,
  description,
  icon,
  button,
  buttonIcon,
  isScreenSize = false,
  link,
  linkButton,
  onClick,
  isLoading,
}: {
  title: string;
  description?: string | ReactNode;
  icon: LucideIcon | NoxusIcon;
  button?: string;
  buttonIcon?: LucideIcon | NoxusIcon;
  link?: string;
  linkButton?: string;
  isScreenSize?: boolean;
  onClick?: (event: React.MouseEvent<HTMLButtonElement>) => void;
  isLoading?: boolean;
}) => {
  const IconComponent = icon;
  const ButtonIcon = buttonIcon;

  return (
    <div
      className={`
        flex flex-col items-center justify-center text-center
        ${isScreenSize ? "w-screen h-screen" : "h-full w-full"}
        gap-4 p-12 text-muted-foreground
      `}
    >
      <IconComponent
        size={48}
        strokeWidth={1.5}
        className="text-muted-foreground"
      />

      <p className="text-xl font-semibold text-foreground">{title}</p>

      {description && (
        <p className="text-sm text-muted-foreground">{description}</p>
      )}

      {button && (
        <Button onClick={onClick} loading={isLoading} className="mt-2">
          {ButtonIcon && <ButtonIcon size={20} strokeWidth={1.25} />}
          {button}
        </Button>
      )}

      {link && (
        <Link href={link} className="mt-8">
          <Button variant="default">{linkButton}</Button>
        </Link>
      )}
    </div>
  );
};

export { NoxusEmptyBlock };
